const authConstant = require("./constant");
const axios = require("axios").default;
const _ = require("lodash");

const getLiveByGroup = async () => {
  const authToken = localStorage.getItem("auth-token");
  const response = await axios.post(
    authConstant.MAIN_URI,
    {
      name: "getLiveByGroup",
      param: {
        usr: localStorage.getItem("username"),
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return _.result(response.data, "response.result") ?? [];
};

export default getLiveByGroup;
